export function getGoogleMapsSearchUrl(address: string): string {
  const query = encodeURIComponent(address.trim());
  return `https://www.google.com/maps/search/?api=1&query=${query}`;
}

export function openGoogleMaps(address: string): void {
  const url = getGoogleMapsSearchUrl(address);
  window.open(url, "_blank", "noopener,noreferrer");
}
